"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupModels = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const groupModels = (models) => {
    const result = {};
    models.forEach(model => {
        const { type } = model;
        switch (type) {
            case bridge_schema_1.ModelType.Male:
                if (!result.male) {
                    result.male = [];
                }
                result.male.push(model);
                break;
            case bridge_schema_1.ModelType.Female:
                if (!result.female) {
                    result.female = [];
                }
                result.female.push(model);
                break;
            default:
                if (!result.detailed) {
                    result.detailed = [];
                }
                result.detailed.push(model);
        }
    });
    return result;
};
exports.groupModels = groupModels;
